// Afișare compactă (implicit) sau normală, ținută în browserul utilizatorului.
const KEY = "onomad_density";

export function getDensity() {
  try { return localStorage.getItem(KEY) === "normal" ? "normal" : "compact"; } catch { return "compact"; }
}

export function applyDensity(d = getDensity()) {
  document.documentElement.classList.toggle("density-compact", d === "compact");
}

export function setDensity(d) {
  try { localStorage.setItem(KEY, d); } catch { /* browser fără stocare: rămâne doar pe sesiune */ }
  applyDensity(d);
}

// Factorul de zoom aplicat paginii (0.85 în afișarea compactă pe ecrane late, altfel 1). Dreptunghiurile din
// getBoundingClientRect() și window.innerWidth/innerHeight sunt în pixeli „reali”; elementele poziționate cu
// left/top au nevoie de pixeli ai paginii, deci se împart la acest factor.
export const COMPACT_ZOOM = 0.85;
export function zoomFactor() {
  try {
    return document.documentElement.classList.contains("density-compact") && window.matchMedia("(min-width: 761px)").matches ? COMPACT_ZOOM : 1;
  } catch { return 1; }
}
// Dreptunghi + dimensiunile ferestrei, în pixeli ai paginii.
export function pageRect(el) {
  const z = zoomFactor(), r = el.getBoundingClientRect();
  return { left: r.left / z, right: r.right / z, top: r.top / z, bottom: r.bottom / z, width: r.width / z, height: r.height / z, vw: window.innerWidth / z, vh: window.innerHeight / z };
}
